const element = document.querySelector('#server-data');
if (element) {
  element.outerHTML = '';
}
